import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { ArrowDown } from "lucide-react";
import { FAQ_ITEMS, IMAGES } from "../data/content";
import { Reveal } from "../components/Reveal";
import { scrollToTarget } from "../lib/scroll";

const FaqSection = () => (
  <section id="faq" data-testid="rnb-faq-page" className="relative py-20 lg:py-32 bg-[#080808] border-y border-zinc-900 overflow-hidden">
    <img src={IMAGES.editorial.bgProCard} alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 h-full w-full object-cover object-center" />
    <div className="absolute inset-0 bg-black/80" aria-hidden="true" />
    <div className="absolute inset-0 bg-gradient-to-b from-[#080808] via-transparent to-[#080808]" aria-hidden="true" />
    <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <p className="text-xs tracking-[0.4em] text-zinc-500 uppercase">Dudas habituales</p>
        <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95]">
          PREGUNTAS <span className="text-transparent" style={{ WebkitTextStroke: "1.5px #fff" }}>FRECUENTES</span>
        </h2>
      </Reveal>
      <Reveal delay={0.2} className="mt-12">
        <Accordion type="single" collapsible data-testid="rnb-faq-accordion" className="w-full text-left">
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-zinc-800" data-testid={`rnb-faq-item-${i + 1}`}>
              <AccordionTrigger className="text-left font-display text-xl sm:text-2xl tracking-wide text-white hover:text-zinc-300 hover:no-underline py-6">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-zinc-400 leading-relaxed font-light pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
      <Reveal delay={0.3} className="mt-12 text-center">
        <p className="font-display text-2xl sm:text-3xl text-white tracking-wide">¿NO ENCUENTRAS TU RESPUESTA?</p>
        <p className="mt-2 text-sm text-zinc-400">Escríbeme y te contesto personalmente.</p>
        <button
          onClick={() => scrollToTarget("#contacto")}
          data-testid="rnb-faq-contact-link"
          className="group mt-6 inline-flex items-center gap-3 bg-white text-black font-display text-xl tracking-[0.15em] px-8 py-4 hover:bg-zinc-200 transition-colors"
        >
          ESCRÍBEME
          <ArrowDown className="h-5 w-5 transition-transform duration-300 group-hover:translate-y-1" />
        </button>
      </Reveal>
    </div>
  </section>
);

export default FaqSection;
